export default {
  toDo: {
    id: 'bo_seller.profile.legal_details.dsa_block.empty_block_content.to_do',
    defaultMessage: 'To do',
  },
  noDsaTitle: {
    id: 'bo_seller.profile.legal_details.dsa_block.empty_block_content.title',
    defaultMessage: 'Add default contact for products',
  },
  noDsaSubtitle: {
    id: 'bo_seller.profile.legal_details.dsa_block.empty_block_content.subtitle',
    defaultMessage:
      "Make sure you're compliant with the new EU regulations for product safety. Starting December 2024, each product you list must include contact details of the business responsible for the product. This information will be displayed on the product page.",
  },
  getStarted: {
    id: 'bo_seller.profile.legal_details.dsa_block.empty_block_content.get_started',
    defaultMessage: "Let's get started",
  },
}
